// extracted by mini-css-extract-plugin
export default {"container":"termPage_container__a+yeQ"};